import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StiiraError } from '@core/models';
import { ErrorService, LayoutService, ProfileService, SnackbarService } from '@core/services';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate } from '@shared/helpers/rxjs.helpers';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { closeDialogOnEscape } from '@shared/helpers';

@Component({
    selector: 'app-change-email',
    templateUrl: './change-email.component.html',
    styleUrls: ['./change-email.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeEmailComponent implements OnInit {
  static readonly componentName = 'ChangeEmailComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  form: UntypedFormGroup;
  isSubmitting$ = new Subject<boolean>();
  public isMobile$: Observable<boolean>;

  get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChangeEmailComponent>,
    private profileService: ProfileService,
    private snackbarService: SnackbarService,
    private errorService: ErrorService,
    @Inject(MAT_DIALOG_DATA) public sysText,
    private layoutService: LayoutService
  ) { }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
    closeDialogOnEscape(this.dialogRef, this.isSubmitting$, () => this.dialogRef.close());

    this.form = this.fb.group({      
      email: ['', Validators.required]
    });
  }

  public changeEmail(): void {
    this.profileService
      .changeEmail({email: this.form.value.email})
      .pipe(
        indicate(this.isSubmitting$),
        finalize(() => { })
      )
      .subscribe(
        () => {
          this.snackbarService.open('Email successfully changed', 'Dismiss');          
          this.dialogRef.close();
        },
        (err: StiiraError) => {
          this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors);
        }
      );
  }
}